import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export const RedirectWithSameParams = ({ from, to }: { from: string; to: string }) => {
  const { pathname, search } = useLocation();

  return <Redirect path={from} to={{ pathname: pathname.replace(from, to), search }} />;
};
